import styled from "styled-components";
import {ButtonSubmit} from "../components/footer/styles";
import {TypeTitle, NameTitle, ContentContainer} from "./Products";
import Color from "../assets/Colors";

const BackView = styled.div`
   width: 100%;
   height: 70vh;
   background-size: cover;
   background-repeat: no-repeat;
   padding-top: 9em;

   @media screen and (max-width: 1600px) {
      padding-top: 7.5em;
   }

   @media screen and (max-width: 500px) {
      padding-top: 5em;
      background-position: center;
      height: 60vh;
      max-height: 500px;
   }
`;

export const View = styled.div`
   background: white;
   // width: 84vw;
   margin: 0 auto;
   margin-top: -4em;
   padding-top: 3em;
   padding-bottom: 4em;

   padding: ${props => props.paddingHead};

   & .principalTitle {
      font-size: 1.6em;
      line-height: 1.7em;
   }

   @media screen and (max-width: 1600px) {
      & .principalTitle {
         font-size: 1.3em;
         line-height: 1.3em;
      }
   }
   @media screen and (max-width: 500px) {
      width: 100%;
      padding-top: 1em;
      //padding-bottom: 2em;

      &.fullWidthPadding {
         width: 92%;
         padding-bottom: 1em;
      }
      & .principalTitle {
         font-size: 1em;
         line-height: 1.2em;
      }
   }
`;

export const BackIcon = styled(ButtonSubmit)`
   padding: 0;
   padding-bottom: 0.3em;
   display: inline-flex;
   align-items: center;
   cursor: pointer;

   color: white;
   font-size: 1em;
   font-weight: 200;
   color: white;

   & img {
      //transform: rotate(180deg);
      margin-right: 1em;
      width: 1.5em;
      height: 1.5em;
      filter: brightness(5);
   }

   @media screen and (max-width: 1600px) {
      & img {
         margin-right: 0.5em;
         width: 1em;
         height: 1em;
      }
      & p {
         font-size: 0.9em;
      }
   }

   @media screen and (max-width: 500px) {
      font-size: 0.8em;
   }
`;

export const HeadCard = styled(ContentContainer)`
   position: relative;
   background: white;
   padding-top: 2em;
   margin-top: -4em;
   //border-bottom: ${props => props.borderNone ? "" : "1px solid rgba(88, 88, 88, 0.55)"};
   padding-bottom: 80px;

   @media screen and (max-width: 500px) {
      width: 105%;
      margin-left: -2.5%;
      padding-bottom: 3px;
   }

   & .content {
      display: flex;
      justify-content: space-between;

      & .titles {
         width: 30%;
      }

      & .itemInfoHead.itemBtnContainer {
         width: 60%;
         margin-top: 2em;

         & .btnModal {
            margin-top: 0;
            font-size: 1.1em;
         }
         @media screen and (max-width: 1600px) {
            & .btnModal {
               font-size: 0.9em;
            }
         }
         @media screen and (max-width: 500px) {
            width: 100%;
            display: none;
         }
      }

      & .desc {
         width: 70%;
         & .infoHead {
            display: flex;
            justify-content: space-around;
            margin-bottom: 3em;

            & .itemInfoHead {
               width: 50%;

               padding: 0;
               display: flex;
               align-items: center;

               & ${TypeTitle} {
                  font-size: 1.1em;
               }

               & ${TypeTitle}, & ${NameTitle} {
                  margin: 0;
                  margin-left: 1em;
                  line-height: 2em;
               }
               & img.deatailInfoIcon {
                  width: 2em;
                  height: 2em;
               }
            }
         }
      }

      & .icon {
         width: 4.5em;
         height: 4.5em;
         position: absolute;
         top: -5em;
         left: 0;
      }

      @media screen and (max-width: 1600px) {
         & .icon {
            top: -4em;
            width: 3.5em;
            height: 3.5em;
         }
         & .desc {
            & .infoHead {
               & .itemInfoHead p {
                  font-size: 0.9em;
                  width: auto;
               }

               & .itemInfoHead {
                  & ${TypeTitle} {
                     font-size: 0.9em;
                  }

                  & ${TypeTitle}, & ${NameTitle} {
                     margin: 0;
                     margin-left: 1em;
                     line-height: 2em;
                  }

                  & img.deatai,
                  & img.deatailInfoIcon {
                     width: 1.5em;
                     height: 1.5em;
                  }
               }
            }
         }
      }

      @media screen and (max-width: 500px) {
         flex-direction: column;
         padding: 3px !important;

         & .titles,
         & .desc {
            width: 100%;
         }
         & .titles {
            margin-bottom: 1em;
         }

         & .icon {
            width: 2.5em;
            height: 2.5em;
            top: -3em;
         }

         & .desc {
            & .infoHead {
               margin-bottom: 2em;

               & .itemInfoHead {
                  padding: 0;

                  & p {
                     font-size: 0.7em;
                     white-space: nowrap;
                  }

                  &:first-child {
                     width: 45%;
                     justify-content: flex-start;
                  }

                  &:nth-child(2) {
                     width: 55%;
                     padding-left: 0.5em;
                     border-right: none;
                  }
                  & img.deatailInfoIcon {
                     width: 1.2em;
                     height: 1.2em;
                     margin-right: 0.5em;
                  }
                  & ${TypeTitle} {
                     font-size: 0.8em;
                  }
                  & ${NameTitle} {
                     font-size: 0.9em;
                  }
               }

               & .itemBtnContainer {
                  display: none;
               }
            }
         }
      }
   }
`;

export const SecondView = styled.div`
   margin-top: 6em;

   @media screen and (max-width: 1600px) {
      margin-top: 2em;
      padding: 0.5em;
   }

   @media screen and (max-width: 500px) {
      padding: 0;
   }
`;
export const TitleSection = styled.div`
   display: flex;
   align-items: center;
   padding-top: 2em;
   font-size: 1.2em;

   & p {
      margin-top: 0;
   }

   & .icon {
      width: 1.5em;
      height: 1.5em;
      margin-right: 1em;
      &.large {
         width: 1.7em;
      }
      &.grand {
         height: 1.7em;
      }
      &.grand2 {
         height: 1.8em;
         width: 2.2em;
      }
   }



   @media screen and (max-width: 1600px) {
      margin-top: 2em;
      font-size: 0.9em;
      & .icon {
         width: 1.3em;
         height: 1.3em;
         margin-right: 0.7em;
      }
   }

   @media screen and (max-width: 500px) {
      & .icon {
         width: 1em;
         height: 1em;
         margin-right: 0.6em;
         &.grand {
            height: 1.3em;
         }

         &.grand2 {
            height: 1.3em;
            width: 1.7em;
         }
      }
   }
`;

export default BackView;

export const TitleViewCard = styled.p`
   color: ${Color.primary};
   font-size: 27px;
   font-weight: 200;
   text-transform: uppercase;
   line-height: 1.5;

   @media screen and (max-width: 1600px) {
      font-size: 23px;
   }

   @media screen and (max-width: 1400px) {
      font-size: 20px;
   }

   @media screen and (max-width: 500px) {
      font-size: 16px;
   }
`;
